// extracted by mini-css-extract-plugin
export default {"PcaScatter_app":"pcascatter_PcaScatter_app__X6L4d"};